/**
 * Возвращает текущее значение скролла страницы
 *
 * @return {number}
 */
export const getCurrentScrollPos = () =>
  document.documentElement.scrollTop || document.body.scrollTop;
